module.exports = __webpack_public_path__ + "static/media/line-type-close-icon.98d2265d.svg";